import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import {
  FailedMessagesProfileItemState,
  FailedMessagesProfileItemStateModel,
} from './failed-messages-profile-item.state';
import {
  FailedMessagesProfileItemLoad,
  FailedMessagesProfileItemCreate,
  FailedMessagesProfileItemUpdate,
  FailedMessagesProfileItemInitialState,
} from './failed-messages-profile-item.actions';
import { FailedMessagesProfileItemFilterModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class FailedMessagesProfileItemFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(FailedMessagesProfileItemState.getProfileId);
  profile$: Observable<FailedMessagesProfileItemStateModel> = this.store.select(
    FailedMessagesProfileItemState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(FailedMessagesProfileItemState.getLoaded);

  constructor(private store: Store, private actions: Actions) {}

  loadAll(shipmentPlannerProfileId: number): void {
    this.store.dispatch(new FailedMessagesProfileItemLoad(shipmentPlannerProfileId));
  }

  createProfile(profile: FailedMessagesProfileItemFilterModel): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new FailedMessagesProfileItemCreate(profile));

    return this.actions.pipe(ofActionCompleted(FailedMessagesProfileItemCreate));
  }

  updateProfile(data: FailedMessagesProfileItemFilterModel): void {
    this.store.dispatch(new FailedMessagesProfileItemUpdate(data));
  }

  setInitialState(): void {
    this.store.dispatch(new FailedMessagesProfileItemInitialState());
  }
}
